<div
  class="popin"
  [@showHide]="isShown ? 'show' : 'hide'"
  (@showHide.done)="onShowHide($event)"
  [style.width.vw]="width"
  [style.maxWidth.vw]="width"
  [style.minWidth.vw]="width"
  [style.right.vw]="calcRight()"
  >
  <div class="popin-title" [class.nopadding]="noTitlePadding">
    <div class="h1 popin-text">
      @if (title === '') {
        <ng-content select=".title"></ng-content>
      }
      @if (title !== '') {
        <aa-popin-title [title]="title"></aa-popin-title>
      }
    </div>
    <div class="h4 popin-close" (click)="onClose()">
      <aa-action-circle class="blueprune1 duotone" [faIcon]="'fal fa-times'"></aa-action-circle>
    </div>
  </div>
  <div class="popin-content">
    <div class="popin-body">
      <ng-content></ng-content>
    </div>
    <div class="popin-footer" [ngClass]="internalBackPic">
      <ng-content select=".popin-content-footer"></ng-content>
      @if (hasCancelButton) {
        &nbsp;&nbsp;
        <aa-btn-action-transparent [btnText]="'BUTTON.CANCEL' | translate" [cta]="onClose">
        </aa-btn-action-transparent>
      }
    </div>
  </div>
</div>
